import { adminHeaders } from "./auth";
import { marketplaceHeaders } from "./marketplaceAuth";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

export async function fetchSpareCategories() {
    const response = await fetch(`${API_URL}/spares/categories`);
    if (!response.ok) {
        throw new Error(`Error fetching spare categories: ${response.statusText}`);
    }
    return response.json();
}

export async function fetchSpares(filters = {}) {
   const params = new URLSearchParams();

   Object.entries(filters).forEach(([key, value]) => {
    if (value  !== undefined && value !== null && value !== "") {
        params.append(key, value);
    }
   });

    const response = await fetch(`${API_URL}/spares?${params.toString()}`, {
        headers: marketplaceHeaders(),
    });
    if (!response.ok) {
        throw new Error(`Error fetching spares: ${response.statusText}`);
    }
    return response.json();
}

export async function fetchSellerSpares() {
    return fetchSpares({ sellerOnly: "true" });
}

export async function fetchSpare(id) {
    const response = await fetch(`${API_URL}/spares/${id}`);
    if (!response.ok) throw new Error(`Error fetching spare: ${response.statusText}`);
    return response.json();
}

export async function recordSpareView(id) {
    const response = await fetch(`${API_URL}/spares/${id}/view`, { method: "POST" });
    if (!response.ok) throw new Error("Unable to record spare part view.");
    return response.json();
}


export async function createSpare(spare) {
    const response = await fetch(`${API_URL}/spares`, {
        method: "POST",
        headers: {
            ...adminHeaders(),
            ...marketplaceHeaders(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(spare),
    });

    if (!response.ok) {
        throw new Error(`Error creating spare: ${response.statusText}`);
    }
    return response.json();
}

export async function updateSpare(id, spare) {
    const response = await fetch(`${API_URL}/spares/${id}`, {
        method: "PUT",
        headers: {
            ...adminHeaders(),
            ...marketplaceHeaders(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(spare),
    });

    if (!response.ok) {
        throw new Error(`Error updating spare: ${response.statusText}`);
    }
    return response.json();
}

export async function deleteSpare(id) {
    const response = await fetch(`${API_URL}/spares/${id}`, {
        method: "DELETE",
        headers: { ...adminHeaders(), ...marketplaceHeaders() },
    });

    if (!response.ok) {
        throw new Error(`Error deleting spare: ${response.statusText}`);
    }
    return true;
}
